import React, { useMemo } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { HorizontalStatsStrip } from '@/components/ui/horizontal-stats-strip';
import {
    Clock,
    CheckCircle2,
    ChefHat,
    DollarSign,
    ClipboardList
} from 'lucide-react';

interface OrderStatsProps {
    stats: {
        total: number;
        pending: number;
        preparing: number;
        ready: number;
        completed: number;
        revenue: number;
    };
    currency: string;
    showRevenue?: boolean;
}

export const OrderStats: React.FC<OrderStatsProps> = ({ stats, currency, showRevenue = false }) => {
    const formatPrice = (price: number) => `${currency} ${price.toFixed(2)}`;

    const statsItems = useMemo(() => {
        const items = [
            { id: 'total', label: 'Total', value: stats.total, icon: ClipboardList, color: 'default' as const },
            { id: 'pending', label: 'Pending', value: stats.pending, icon: Clock, color: 'yellow' as const },
            { id: 'preparing', label: 'Preparing', value: stats.preparing, icon: ChefHat, color: 'orange' as const },
            { id: 'ready', label: 'Ready', value: stats.ready, icon: CheckCircle2, color: 'green' as const },
            { id: 'completed', label: 'Completed', value: stats.completed, icon: CheckCircle2, color: 'gray' as const },
        ];

        if (showRevenue) {
            items.push({ id: 'revenue', label: 'Revenue', value: formatPrice(stats.revenue), icon: DollarSign, color: 'blue' as const });
        }

        return items;
    }, [stats, showRevenue, currency]);

    return (
        <div className="mb-4 md:mb-6">
            <HorizontalStatsStrip stats={statsItems} columns={6} />
        </div>
    );
};
